import React, { useState, useEffect, useRef } from 'react';
import { SwiperControl } from '../SwiperControl.js';
import { useSwiper } from 'swiper/react';
import { loadListData } from '../helpers/HelperFunctions.js';
import { listTypes } from '../../constants.js';
import i18n from '../../i18n.js';

const NewsItem = (props) => {
    const [canExpand, setCanExpand] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [contentHeight, setContentHeight] = useState(50);
    const contentRef = useRef(null);
    const swiper = useSwiper();

    useEffect(() => {
        if (contentRef.current) {
            const contentHeight = contentRef.current.scrollHeight;
            const visibleHeight = contentRef.current.clientHeight;
            if (contentHeight > visibleHeight) {
                setContentHeight(contentHeight + 20);
                setCanExpand(true);
            }
        }
    }, [])

    const getContentRows = (content) => {
        return content.split('\n');
    }

    const handleSlideChange = (swiper) => {
        if (expanded) {
            let slidesPerView = 1;
            switch (swiper.currentBreakpoint) {
                case '768':
                    slidesPerView = 2;
                    break;
                case '1025':
                    slidesPerView = 3;
                    break;
                case '1401':
                    slidesPerView = 4;
                    break;
            }
            let needCollapse = true;
            let index = swiper.activeIndex;
            let i = 0;
            while (i < slidesPerView) {
                const slide = swiper.slides[index];
                if (parseInt(slide.getAttribute('data-swiper-slide-index')) === props.item.index) {
                    needCollapse = false;
                    break;
                }
                index++;
                if (index >= swiper.slides.length) index = 0;
                i++;
            }

            if (needCollapse) {
                setExpanded(false);
            }            
        }
    }

    swiper.on('slideChange', handleSlideChange);

    const handleClick = () => {
        if (canExpand) {
            if (swiper) {
                if (expanded) {
                    swiper.autoplay.start();
                }
                else {
                    swiper.autoplay.stop();
                }
            }
            props.item.onExpand(!expanded);
            setExpanded(!expanded);
        }
    }

    let content = '';
    const contentField = props.item.fields.find(f => f.name === 'Content');
    if (contentField) content = contentField.value;
    return <div className={"news-item" + (expanded ? " expanded" : "")} onClick={handleClick} >
        <div className={"news-content" + (expanded ? " expanded" : "")} ref={contentRef} style={{ height: `${(expanded ? contentHeight : 44)}px` }} >
            {getContentRows(content).map((row, index) => <p key={index} >{row}</p>)}
        </div>
        <div className="collapse-btn">{i18n.t('other.collapse')}</div>
    </div>
}

const LastNewsWidget = () => {
    const [items, setItems] = useState(null);
    const [autoplay, setAutoplay] = useState(true);

    const expandHandler = (expanded) => {
        setAutoplay(!expanded)
    }

    useEffect(() => {
        loadListData(listTypes.News).then(data => {
            if (data && data.items && data.items.length > 0) {
                data.items.forEach((item, index) => {
                    item.onExpand = expandHandler;
                    item.index = index;
                });
                setItems(data.items);
            }
        });
    }, [])

    return (<div className="widget last-news">
        {items && <SwiperControl items={items} itemComponent={NewsItem} autoplay={autoplay} spaceBetween={3} type={listTypes.News} />}
    </div>);
}

export default LastNewsWidget;